import { Building } from "lucide-react";

interface TradesmanLogoProps {
  logoUrl?: string | null;
  companyName?: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export function TradesmanLogo({ 
  logoUrl, 
  companyName = "Company", 
  size = "md",
  className = ""
}: TradesmanLogoProps) {
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8", 
    lg: "h-12 w-12",
    xl: "h-16 w-16"
  };

  const iconSizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-6 w-6", 
    xl: "h-8 w-8"
  };

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${companyName} logo`}
        className={`${sizeClasses[size]} object-contain rounded border bg-background p-1 ${className}`}
      />
    );
  }

  return (
    <div className={`${sizeClasses[size]} rounded border bg-muted flex items-center justify-center ${className}`}>
      <Building className={`${iconSizeClasses[size]} text-muted-foreground`} />
    </div>
  );
}